import { useCallback } from 'react';

import { useNotificationUpdate } from './use-notification-update';

export const useNotificationMarkAsOld = () => {
  const [updateNotification, ...rest] = useNotificationUpdate();

  const markAsOld = useCallback(
    async (notificationIds: string[]) => {
      await updateNotification({ notificationIds, isNew: false });
    },
    [updateNotification]
  );

  return [markAsOld, rest] as const;
};
